<template>
  <div>
    <h3>Business Information</h3>
    <div v-if="iff_prefill && iff_prefill.fn">
      <p>Please confirm that the information below is correct.</p>
      <div class="iff-confirm">
        <p style="font-size: 20px; font-weight: bold">
          {{ iff_prefill.fn }} {{ iff_prefill.ln }}
        </p>
        <p style="margin-bottom: 0px">{{ iff_prefill.address }}</p>
        <p>
          {{ iff_prefill.city }}, {{ iff_prefill.state }} {{ iff_prefill.zip }}
        </p>
      </div>
      <div class="buttons is-right">
        <!-- <a v-if="!validate" class="button is-link is-inverted padded-button next-button" @click="back">Back</a> -->
        <a
          class="button is-link padded-button next-button"
          :class="clicked ? 'is-loading' : ''"
          @click="acceptMatch"
          >Confirm</a
        >
        <a class="button is-link is-inverted decline-button" @click="next"
          >This is not my information.</a
        >
      </div>
    </div>
    <div v-else>
      <SmallCheckbox
        :inputField="inputs.home_based_business"
        inputName="Home Based Business?"
        inputType="string"
      />
      <AddressInput
        :inputField="inputs.biz_address"
        inputName="Physical Business Address (No P.O. Boxes)"
        inputType="string"
        @selectedAddress="updateAddress"
      />
      <i
        v-show="selected_address == true"
        class="address_selected fas fa-check"
      ></i
      >&nbsp;
      <i
        v-show="selected_address == false"
        class="address_selected"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="14" viewBox="0 0 11 14" fill="none">
          <path d="M5.69565 13C5.69565 13 10.3913 8.82609 10.3913 5.69565C10.3913 3.10231 8.28899 1 5.69565 1C3.10232 1 1 3.10231 1 5.69565C1 8.82609 5.69565 13 5.69565 13Z" stroke="#999999"/>
          <path d="M7.19585 5.5001C7.19585 6.32852 6.52427 7.0001 5.69585 7.0001C4.86742 7.0001 4.19584 6.32852 4.19584 5.5001C4.19584 4.67167 4.86742 4.0001 5.69585 4.0001C6.52427 4.0001 7.19585 4.67167 7.19585 5.5001Z" stroke="#999999"/>
        </svg>
      </i>&nbsp; <label class="label full_address">{{ full_address }}</label>&nbsp;
      <a class="toggle_address" href="javascript:void(0)" @click="toggleAddressFields" role="button">
        Or enter address manually
      </a>
      <Input
        @enter="next"
        :inputField="inputs.biz_city"
        inputName="City"
        inputType="string"
        ref="city"
        autocomplete="address-level2"
        v-show="show_address_fields == true"
      />
      <div id="state_container" v-show="show_address_fields == true">
        <Input
          @enter="next"
          :inputField="inputs.biz_state"
          inputName="State"
          inputType="state"
          ref="state"
          autocomplete="address-level1"
          v-show="show_address_fields == true"
        />
        <Input
          @enter="next"
          :inputField="inputs.biz_zip"
          inputName="Zip Code"
          inputType="zip"
          ref="zip"
          autocomplete="postal-code"
          v-show="show_address_fields == true"
        />
      </div>

      <Input
        @enter="next"
        :inputField="inputs.ownership"
        inputName="Ownership Percentage"
        inputType="percent"
        :range="[1, 100]"
        :icons="{ right: 'fa-percent' }"
      />
      <div
        style="
          background: #f6f6f6;
          padding: 20px;
          border-radius: 5px;
          margin-bottom: 20px;
        "
      >
        <p
          style="
            color: #A5A5A5;
            display: block;
            font-size: 1rem;
            font-weight: 500;
            margin-bottom: 5px;
            font-family: 'Roboto';">
          Last 4 Digits of SSN
        </p>
        <div style="display: flex; margin-bottom: 10px">
          <div
            style="
              flex-shrink: 1;
              padding: 5px;
              margin-top: 12px;
              margin-right: 5px;
              text-align: justify;
              color: #666;
              font-family: 'Roboto';"
            >
            XXX-XX-
          </div>
          <div style="flex: 1">
            <Input
              @enter="next"
              :inputField="inputs.ssn"
              inputName=""
              placeholder="XXXX"
              inputType="last4"
              :icons="{ right: 'fa-lock' }"
            />
          </div>
        </div>
        <Input
          @enter="next"
          :inputField="inputs.zip"
          inputName="Home Zip Code"
          inputType="zip"
          ref="zip"
        />
        <!-- <div style="text-align: center;">
          <label id="powered_by_exp_logo">Powered by</label>
          <img id="experian_logo_image" src="../../../../src/assets/img/experian_logo.png" width="76" height="24" alt="experian logo">
        </div> -->
      </div>
      <!-- <Checkbox
        :inputField="inputs.consent"
        inputName="IFF Consent"
        inputType="required"
      >
        You understand that by clicking <strong>"Continue"</strong> immediately
        below you are authorizing Experian to disclose your personally
        identifiable information or other information to Cardiff on your behalf
        solely to prefill your application.
      </Checkbox> -->
      <br/>
      <input type="hidden" id="atadlauqID" name="atadlauqID" />
      <label class="label" id="agree_label">
        By clicking continue you are authorizing Experian to disclose your personally identifiable information or other information to Cardiff 
        on your behalf solely to prefill your application.
      </label>
      <div class="buttons is-right" style="margin-bottom: 0px;">
        <!-- <a v-if="!validate" class="button is-link is-inverted padded-button next-button" @click="back">Back</a> -->
        <a
          class="button is-link padded-button next-button continue-button"
          :class="clicked ? 'is-loading' : ''"
          @click="sendFNRequest"
          >Continue</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import Input from "@/components/shared/Input";
import AddressInput from "@/components/shared/AddressInput";
// import Dropdown from "@/components/shared/Dropdown";
// import Checkbox from "@/components/shared/Checkbox";
import ApplyPage from "@/components/shared/ApplyPage";
// import List from "@/components/shared/List";

// import List from "@/components/shared/List";
import SmallCheckbox from "@/components/shared/SmallCheckbox";
import moment from "moment";

function getWithExpiry(key) {
  const itemStr = localStorage.getItem(key);
  // if the item doesn't exist, return null
  if (!itemStr) {
    return null;
  }
  const item = JSON.parse(itemStr);
  const now = new Date();
  // compare the expiry time of the item with the current time
  if (now.getTime() > item.expiry) {
    // If the item is expired, delete the item from storage
    // and return null
    localStorage.removeItem(key);
    return null;
  }
  return item.value;
}

export default {
  name: "IFF",
  components: {
    Input,
    AddressInput,
    SmallCheckbox
    // Checkbox,
    // List
  },
  props: {
    api: String,
    link: String,
  },
  mixins: [ApplyPage],
  created: function(){
  },
  mounted: function () {
    console.log("mounted iff");
    let company_name = getWithExpiry("company_name");
    if (company_name && company_name !== "") {
      this.company_name = company_name;
    }

    //writes to the hidden input
    atadlauq.atadlauqc("atadlauqID");
  },
  methods: {
    sendFNRequest: function () {
      let self = this;
      // this.validate()
      const jsc = document.getElementById("atadlauqID").value;
      const hdm = document.getElementById("user_prefs2").value;
      console.log("got jsc", jsc);
      console.log("got hdm", hdm);

      // self.next()
      self.clicked = true;
      if (!self.validateInPlace()) {
        console.log("not sending any request until this is valid");
        self.clicked = false;
        return;
      }
      $.ajax({
        type: "POST",
        url: "/api/" + self.api + "/iff-match",
        contentType: "application/json",
        dataType: "json",
        data: JSON.stringify({
          jsc: jsc,
          hdm: hdm,
          last4: self.inputs.ssn.value,
          zip: self.inputs.zip.value,
          link: self.link,
        }),
      })
        .done(function (resp) {
          console.log("iff matched", resp);

          let m = moment(resp.model.dob);
          resp.model.dob = m.format("YYYY-MM-DD");

          self.iff_prefill = resp.model;
          self.clicked = false;
          // self.next()
        })
        .fail(function (err) {
          console.log(JSON.stringify(err));
          self.clicked = false;
          // alert(err)
          self.next();
        });

      console.log("moving on");
    },
    acceptMatch: function () {
      let self = this;
      if (self.clicked) {
        return;
      }
      self.clicked = true;
      console.log(
        "accepting - send page 4 style request and move forward 2 pages"
      );
      self.next();
    },
    updateAddress: function (data) {
      console.log("update address");
      console.log(data);
      this.inputs.biz_city.value = data.city;
      this.inputs.biz_state.value = data.state;
      this.inputs.biz_zip.value = data.zip;
      if (
        data.city &&
        data.city !== "" &&
        data.state &&
        data.state !== "" &&
        data.zip &&
        data.zip !== ""
      ) {
        console.log('changing..')
        // this.show_address_fields = false;
        this.selected_address = true;
        this.full_address =
          data.street_number +
          " " +
          data.street +
          ", " +
          data.city +
          ", " +
          data.state +
          ", " +
          data.zip;
      }
    },
    toggleAddressFields: function () {
      this.show_address_fields = !this.show_address_fields;
    },
  },
  data() {
    return {
      obj: "pg",
      clicked: false,
      iff_prefill: null,
      ficoOptions: [
        "<550",
        "550-600",
        "600-650", 
        "650-700",
        "700-750",
        "750+",
      ],
      inputs: {
        // srfico: Input.model(),
        ssn: Input.model(),
        biz_address: AddressInput.model(),
        biz_city: Input.model(),
        biz_state: Input.model(),
        biz_zip: Input.model(),
        home_based_business: Input.model(),
        address: AddressInput.model(),
        city: Input.model(),
        state: Input.model(),
        zip: Input.model(),
        dob: Input.model(),
        ownership: Input.model(),
        consent: Input.model(),
      },
      company_name: "",
      selected_address: false,
      show_address_fields: false,
      full_address : '',
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.decline-button {
  padding: 5px !important;
  margin-top: 20px;
  width: 100%;
}

.iff-confirm {
  width: 100%;
  margin: 20px 0px;
  background: #efefef;
  padding: 20px;
  border-radius: 5px;
  text-align: center;
}
.eligibility_label {
  font-weight: 500;
}
#agree_label{
  /* margin-left: 20px;
  font-size: 14px; */
  margin:  59px 5px 48px 5px;
  color: #A5A5A5;

  font-family: Roboto;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
#powered_by_exp_logo{
  color: #666;
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-right: 10px;
  position: relative;
  top: -7px;
}
#experian_logo_image{
  margin-top: 18px;
}
.toggle_address {
  /* color: #666; */
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 166.667% */
  margin-bottom: 20px;
  display: inline-block;
}
.address_selected {
  color: green;
}
/* start google address */
.full_address {
  color: gray;
  display: inline-block;
  margin-bottom: 10px;
}
#state_container{
  display: inline-flex;
  width: 100%;
}
#state_container div{
  width: 50%;
  margin-right: 10px;
}
@media (max-width: 80em) {
  .full_address {
    margin-bottom: 0px;
  }
  .toggle_address {
    margin-bottom: 18px;
    display: inline-block;
  }
}
@media (max-width: 47.999em) {
  .full_address {
    margin-bottom: 0px;
  }
  .toggle_address {
    margin-bottom: 18px;
    display: inline-block;
  }
}
</style>
